import Instagram from './assets/Instagram';
import Facebook from './assets/Facebook';
import Whatsapp from './assets/Whatsapp';
import X from './assets/X';
import { SocialMedia } from '../editor/settings/SocialSettings';

interface Props extends SocialMedia {
    icon: 'whatsapp' | 'instagram' | 'facebook' | 'x';
}

const SocialMediaIcon = ({ icon, ...props }: Props) => {
    if (icon === 'whatsapp') return <Whatsapp {...props} />
    if (icon === 'facebook') return <Facebook {...props} />
    if (icon === 'instagram') return <Instagram {...props} />
    if (icon === 'x') return <X {...props} />
    return null;
}

export default SocialMediaIcon;
